
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTime = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14 8.5c-.254 3.08-2.854 5.5-6 5.5a6 6 0 0 1-6-6c0-3.146 2.42-5.746 5.5-6",
  stroke: "var(--theme-primary, #9631FF)",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 4.5V8h3.5",
  stroke: "var(--theme-primary, #9631FF)",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M10 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM12.25 4.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM13.75 6.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
  fill: "var(--theme-primary, #9631FF)",
  stroke: "var(--theme-primary, #9631FF)",
  strokeWidth: 0.2
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\">\r\n<path d=\"M14 8.5C13.7456 11.58 11.1456 14 8 14C6.4087 14 4.88258 13.3679 3.75736 12.2426C2.63214 11.1174 2 9.5913 2 8C2 4.85437 4.42 2.25438 7.5 2\" stroke=\"var(--theme-primary, #9631FF)\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M8 4.5V8H11.5\" stroke=\"var(--theme-primary, #9631FF)\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M10 3C10.4142 3 10.75 2.66421 10.75 2.25C10.75 1.83579 10.4142 1.5 10 1.5C9.58579 1.5 9.25 1.83579 9.25 2.25C9.25 2.66421 9.58579 3 10 3Z\" fill=\"var(--theme-primary, #9631FF)\" stroke=\"var(--theme-primary, #9631FF)\" stroke-width=\"0.2\"/>\r\n<path d=\"M12.25 4.5C12.6642 4.5 13 4.16421 13 3.75C13 3.33579 12.6642 3 12.25 3C11.8358 3 11.5 3.33579 11.5 3.75C11.5 4.16421 11.8358 4.5 12.25 4.5Z\" fill=\"var(--theme-primary, #9631FF)\" stroke=\"var(--theme-primary, #9631FF)\" stroke-width=\"0.2\"/>\r\n<path d=\"M13.75 6.75C14.1642 6.75 14.5 6.41421 14.5 6C14.5 5.58579 14.1642 5.25 13.75 5.25C13.3358 5.25 13 5.58579 13 6C13 6.41421 13.3358 6.75 13.75 6.75Z\" fill=\"var(--theme-primary, #9631FF)\" stroke=\"var(--theme-primary, #9631FF)\" stroke-width=\"0.2\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/time.9080e1d9dd45370031c388dde34b3f7d.svg"),
        {
          React: SvgTime,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      